"use client";

import { Button } from "../Button";
import { useTheme } from "./ThemeProvider";

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();

  const cycleTheme = () => {
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("nightbox");
    } else {
      setTheme("light");
    }
  };

  const getThemeIcon = () => {
    switch (theme) {
      case "light":
        return "☀️";
      case "dark":
        return "🌙";
      case "nightbox":
        return "🟢";
      default:
        return "☀️";
    }
  };

  const getThemeLabel = () => {
    switch (theme) {
      case "light":
        return "Light Mode";
      case "dark":
        return "Dark Mode";
      case "nightbox":
        return "NightBox Mode";
      default:
        return "Light Mode";
    }
  };

  return (
    <Button
      size="sm"
      onClick={cycleTheme}
      aria-label={`Switch to next theme. Current: ${getThemeLabel()}`}
      className="bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-600 nightbox:bg-emerald-700 nightbox:hover:bg-emerald-600 text-white font-medium"
      title={getThemeLabel()}
    >
      <span className="text-lg">
        {getThemeIcon()}
      </span>
      <span className="sr-only">{getThemeLabel()}</span>
    </Button>
  );
}
